import React, { Component } from 'react';
import ReactSelect from 'react-select';
import './PrinterDetails.scss';
import { Icons } from '../../../utilities';
import { connect } from 'react-redux';
import * as vanillaDesignActions from '../../../redux/vanillaDesignActions';
import { bindActionCreators } from 'redux';
import { Modal } from 'reactstrap';
import { string } from '../../../localization';
import * as Constants from '../../../utilities/constants/Constants';

class PrinterDetails extends Component {
  state = {
    printerName: null,
    userType: null,
    serialNumber: null,
    printerNameIsSelected: true,
    serialNumberIsvalid: true,
    userTypeIsSelected: true,
    showErrorMessage: false
  };

  printerChangeHandler = value => {
    this.setState({ printerName: value });
  };

  userTypeChangeHandler = value => {
    this.setState({ userType: value });
  };

  getSerialnumber = value => {
    this.setState({ serialNumber: value });
  };

  getErrorMessage = () => {
    const {
      printerNameIsSelected,
      serialNumber,
      userTypeIsSelected,
      serialNumberIsvalid
    } = this.state;

    const { errorOnAddingPrinter } = this.props;

    if (!printerNameIsSelected) {
      return string.INVALID_PRINTER_MODEL_KEY;
    }
    if (serialNumber === '') {
      return string.INVALID_SERIAL_NUMBER_KEY;
    }
    if (!userTypeIsSelected) {
      return string.INAVLID_USER_TYPE_KEY;
    }
    if (printerNameIsSelected && userTypeIsSelected && serialNumberIsvalid) {
      return errorOnAddingPrinter;
    }
    return '';
  };

  setFieldValidity = (
    error,
    validPrinterName,
    validSerialNumber,
    validuserType
  ) => {
    this.setState({
      showErrorMessage: error,
      printerNameIsSelected: validPrinterName,
      serialNumberIsvalid: validSerialNumber,
      userTypeIsSelected: validuserType
    });
  };

  submitDetails = () => {
    const { printerName, serialNumber, userType } = this.state;
    const { dispatchers } = this.props;

    if (printerName === null) {
      this.setFieldValidity(true, false, true, true);
    } else if (serialNumber === null || serialNumber === '') {
      this.setFieldValidity(true, true, false, true);
    } else if (userType === null) {
      this.setFieldValidity(true, true, true, false);
    } else {
      this.setFieldValidity(true, true, true, true);

      dispatchers.vanillaDesignActions.sendPrinterDetails(
        serialNumber,
        userType.label,
        printerName.value
      );
    }
  };

  render() {
    const {
      printerNameIsSelected,
      userTypeIsSelected,
      printerName,
      serialNumber,
      userType,
      serialNumberIsvalid,
      showErrorMessage
    } = this.state;
    const {
      addPrinterWindowIsOpen,
      currentPageIndex,
      dispatchers,
      printersList,
      userList
    } = this.props;

    const printerSelectorStyle = {
      control: base => ({
        ...base,
        '&:hover': 'none',
        border: !printerNameIsSelected
          ? '1px solid red'
          : '1px solid rgb(128, 128, 128)',
        borderRadius: '0px',
        fontSize: '12px',
        fontWeight: 'bold',
        boxShadow: 'none'
      }),
      option: provided => ({
        ...provided,
        fontSize: '13px',
        fontWeight: 'bold',
        textAlign: 'left',
        color: 'black',
        '&:hover': { backgroundColor: '#5CACEE' }
      }),
      singleValue: base => ({
        ...base,
        color: 'rgb(0,0,0)',
        fontSize: '13px'
      }),
      indicatorSeparator: base => ({
        ...base,
        height: '40px',
        width: '2px',
        margin: 0,
        backgroundColor: !printerNameIsSelected ? 'red' : 'rgba(0,0,0,0.5)'
      })
    };

    const userTypeSelectorStyle = {
      control: base => ({
        ...base,
        '&:hover': 'none',
        border: !userTypeIsSelected
          ? '1px solid red'
          : '1px solid rgb(128, 128, 128)',
        borderRadius: '0px',
        fontSize: '12px',
        fontWeight: 'bold',
        '&:focus': { borderColor: 'green' },

        boxShadow: 'none'
      }),
      option: provided => ({
        ...provided,
        fontSize: '13px',
        fontWeight: 'bold',
        textAlign: 'left',
        color: 'black',
        '&:hover': { backgroundColor: '#5CACEE' }
      }),
      singleValue: base => ({
        ...base,
        color: 'rgb(0,0,0)',
        fontSize: '13px'
      }),
      indicatorSeparator: base => ({
        ...base,
        height: '40px',
        width: '2px',
        margin: 0,
        backgroundColor: !userTypeIsSelected ? 'red' : 'rgba(0,0,0,0.5)'
      })
    };
    return (
      <Modal
        isOpen={addPrinterWindowIsOpen}
        modalClassName='printer-detail-modal'
      >
        <div className='printer-details-vanilla'>
          <div className='header'>
            <button
              type='button'
              aria-label='close'
              className='close-icon'
              onClick={() =>
                dispatchers.vanillaDesignActions.handleAddPrinterWindow(false)
              }
            />
          </div>
          <div className='body'>
            <p className='title'>{string.ALMOST_DONE_TITLE_KEY}</p>
            <p className='message'>{string.PRINTING_ENABLE_DETAILS_KEY}</p>
            <div className='require-field'>
              <span className='asterisk'>{Constants.ASTERISK}</span>{' '}
              {string.REQUIRED_FIELDS_TEXT_KEY}
            </div>
            <ReactSelect
              classNamePrefix='react-select'
              value={printerName}
              options={printersList}
              onChange={e => this.printerChangeHandler(e)}
              styles={printerSelectorStyle}
              placeholder={string.PRINTER_MODELS_KEY}
            />
            <input
              className={`serial-num ${
                !serialNumberIsvalid ? 'serial-num-invalid' : null
              }`}
              type='text'
              value={serialNumber}
              placeholder={string.PRINTER_SERIAL_NUMBER_KEY}
              onChange={e => this.getSerialnumber(e.target.value)}
            />
            <img
              src={Icons.infohelpIcon}
              className='info-icon'
              alt='info-icon'
            />
            <ReactSelect
              classNamePrefix='react-select'
              value={userType}
              options={userList}
              required
              onChange={e => this.userTypeChangeHandler(e)}
              styles={userTypeSelectorStyle}
              placeholder={string.USER_TYPE_TITLE_KEY}
            />

            <div className='hint'>{string.AGREE_FOR_PRIVACY_TITLE_KEY}</div>
            <button
              type='button'
              className='info'
              onClick={() =>
                window.open(Constants.TERMS_OF_USE_PRINTER, '_blank')
              }
            >
              {string.TERMS_OF_USE_KEY}
            </button>

            <div className=''>
              <button
                type='button'
                className='button done'
                onClick={() => this.submitDetails()}
              >
                {string.DONE_KEY}
              </button>
              {showErrorMessage ? (
                <div className='error-message'>{this.getErrorMessage()}</div>
              ) : null}
              {currentPageIndex !== Constants.FINAL_CHECK_PAGE ? (
                <button
                  type='button'
                  className='button finish-later'
                  onClick={() =>
                    dispatchers.vanillaDesignActions.handleAddPrinterWindow(
                      false
                    )
                  }
                >
                  {string.FINISH_LATER_KEY}
                </button>
              ) : null}
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    printersList: state.vanilla.printersList,
    userList: state.vanilla.userList,
    addPrinterWindowIsOpen: state.vanilla.addPrinterWindowIsOpen,
    errorOnAddingPrinter: state.vanilla.errorOnAddingPrinter,
    currentPageIndex: state.pageController.currentPageIndex,
    storeData: state.modal.storeData
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      vanillaDesignActions: bindActionCreators(vanillaDesignActions, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PrinterDetails);
